__turbopack_context__.v({
  "accentLine": "EligibilityModal-module-scss-module__84qh8q__accentLine",
  "buttonGroup": "EligibilityModal-module-scss-module__84qh8q__buttonGroup",
  "closeButton": "EligibilityModal-module-scss-module__84qh8q__closeButton",
  "content": "EligibilityModal-module-scss-module__84qh8q__content",
  "description": "EligibilityModal-module-scss-module__84qh8q__description",
  "fadeIn": "EligibilityModal-module-scss-module__84qh8q__fadeIn",
  "header": "EligibilityModal-module-scss-module__84qh8q__header",
  "input": "EligibilityModal-module-scss-module__84qh8q__input",
  "inputSection": "EligibilityModal-module-scss-module__84qh8q__inputSection",
  "label": "EligibilityModal-module-scss-module__84qh8q__label",
  "modal": "EligibilityModal-module-scss-module__84qh8q__modal",
  "modalLarge": "EligibilityModal-module-scss-module__84qh8q__modalLarge",
  "modalWrapper": "EligibilityModal-module-scss-module__84qh8q__modalWrapper",
  "overlay": "EligibilityModal-module-scss-module__84qh8q__overlay",
  "primaryButton": "EligibilityModal-module-scss-module__84qh8q__primaryButton",
  "secondaryButton": "EligibilityModal-module-scss-module__84qh8q__secondaryButton",
  "slideIn": "EligibilityModal-module-scss-module__84qh8q__slideIn",
  "title": "EligibilityModal-module-scss-module__84qh8q__title",
});
